// extracted by mini-css-extract-plugin
export default {"solution":"Solution_solution__K6jJs"};